import stopper from '../img/stopper.jpg';
import mooring from '../img/mooring.jpg';
import axiom from '../img/axiom.jpg';
import lifejacket from '../img/lifejacket.jpg';

export const dataMew = [
    {
        title: 'Rope stop RC750/ 3 sections',
        pic: stopper,
    },

    {
        title: 'Mooring Spring',
        pic: mooring,
    },

    {
        title: 'AXIOM+ 7 / Touch',
        pic: axiom,
    },

    {
        title: 'XD 220 Life Jacket / red/black',
        pic: lifejacket,
    },
]